import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { useAuthStore } from '@/stores/auth';
import { Login } from '@/pages/Login';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { ConsoleShell } from '@/layouts/ConsoleShell';
import { Dashboard } from '@/pages/Dashboard';
import { Tenants } from '@/pages/Tenants';
import { Plans } from '@/pages/Plans';
import { Billing } from '@/pages/Billing';
import { Monitoring } from '@/pages/Monitoring';
import { Support } from '@/pages/Support';
import { Master } from '@/pages/Master';
import { Leads } from '@/pages/Leads';
import { Profile } from '@/pages/Profile';
import { Certificates } from '@/pages/Certificates';
import { Users } from '@/pages/Users';
import { Contacts } from '@/pages/Contacts';
import { Legal } from '@/pages/Legal';
import { Templates } from '@/pages/Templates';
import { ExcelTemplates } from '@/pages/ExcelTemplates';
import { ExcelFormBuilder } from '@/pages/ExcelFormBuilder';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  return isLoggedIn ? <>{children}</> : <Navigate to="/login" replace />;
}

// Vite の BASE_URL（/console/ または /mock/console/）をそのまま basename に使用
const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

export function AppRouter() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<ProtectedRoute><ConsoleShell /></ProtectedRoute>}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="plans" element={<Plans />} />
          <Route path="billing" element={<Billing />} />
          <Route path="monitoring" element={<Monitoring />} />
          <Route path="support" element={<Support />} />
          <Route path="master" element={<Master />} />
          <Route path="leads" element={<Leads />} />
          <Route path="certificates" element={<Certificates />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="users" element={<Users />} />
          <Route path="legal" element={<Legal />} />
          <Route path="templates" element={<Templates />} />
          <Route path="excel-templates" element={<ExcelTemplates />} />
          <Route path="excel-templates/:id/builder" element={<ExcelFormBuilder />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
